var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"m-auto",attrs:{"width":"95%"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":[_vm.remarksInfo],"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.sno",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(item.length)+"1")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }